import { render } from "./FavoriteDocumentCard.vue?vue&type=template&id=383c1d7a&scoped=true"
import script from "./FavoriteDocumentCard.vue?vue&type=script&lang=js"
export * from "./FavoriteDocumentCard.vue?vue&type=script&lang=js"

import "./FavoriteDocumentCard.vue?vue&type=style&index=0&id=383c1d7a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-383c1d7a"]])

export default __exports__